





































































































































































































































































































import { Component, Vue, Ref, Watch } from 'vue-property-decorator'
import Chart from '@/components/Chart/index.vue'
import ClassChange from '@/components/ClassChange/index.vue'
import { morningCheckStatic, morningCheckPieStatic, morningCheckNumber, healthExport } from '@/api/health/healthStatic'

  @Component({
    name: 'CampusList',
    components: {
      Chart,
      ClassChange
    }
  })

export default class extends Vue {
    private staticTime:(string | number)[] = [Date.now() - 6 * 24 * 60 * 60 * 1000, Date.now()]
    private staticForm:any = {
      fromTime: Date.now() - 6 * 24 * 60 * 60 * 1000,
      toTime: Date.now(),
      checkType: 102
    }
    private options:any = {
      color: ['#7CB8F8', '#FFD805', '#FF8A8A'],
      tooltip: {
        trigger: 'axis',
        axisPointer: { // 坐标轴指示器，坐标轴触发有效
          type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
        }
      },
      legend: {
        data: ['已检查-正常', '已检查-异常', '未检查']
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: [{
        type: 'category',
        name: '日期',
        data: []
      }],
      yAxis: [{ type: 'value', name: '单位：人' }],
      series: [
        {
          name: '已检查-正常',
          type: 'bar',
          stack: '晨检',
          data: []
        },
        {
          name: '已检查-异常',
          type: 'bar',
          stack: '晨检',
          data: []
        },
        {
          name: '未检查',
          type: 'bar',
          stack: '晨检',
          data: []
        }
      ]
    }
    private recordForm:any = {
      time: Date.now(),
      classroomId: '',
      checkType: 102
    }
    private tabType:number = 100
    // 检查情况饼图
    private checkPieChartVos:any = {
      title: {
        text: '',
        subtext: '数量(人)',
        top: '35%',
        left: '50%',
        textAlign: 'center',
        textStyle: {
          fontSize: '20'
        }
      },
      color: ['#FE5578', '#6C5CE7', '#1875F0', '#1CD1A1'],
      tooltip: {
        trigger: 'item',
        formatter(item:any) {
          let content = ''
          content = item.name + ':' + ' ' + item.value + '人'
          return content
        }
      },
      legend: {
        orient: 'vertical',
        left: 0,
        bottom: 0,
        formatter: (name:string) => {
          let content = ''
          this.checkPieChartVos.series[0].data.map((item:any) => {
            if (item.name === name) {
              content = item.name + ' ' + item.value + '人 ' + item.precent
            }
          })
          return content
        }
      },
      series: [
        {
          name: '人数',
          type: 'pie',
          radius: ['45%', '60%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              color: '#f00'
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          },
          data: []
        }
      ]
    }
    // 检查结果饼图
    private resultPieChartVos:any = {
      title: {
        text: '',
        subtext: '数量(人)',
        top: '35%',
        left: '50%',
        textAlign: 'center',
        textStyle: {
          fontSize: '20'
        }
      },
      color: ['#FE5578', '#6C5CE7', '#1875F0', '#1CD1A1'],
      tooltip: {
        trigger: 'item',
        formatter(item:any) {
          let content = ''
          content = item.name + ':' + ' ' + item.value + '人'
          return content
        }
      },
      legend: {
        orient: 'vertical',
        left: 0,
        bottom: 0,
        formatter: (name:string) => {
          let content = ''
          this.resultPieChartVos.series[0].data.map((item:any) => {
            if (item.name === name) {
              content = item.name + ' ' + item.value + '人 ' + item.precent
            }
          })
          return content
        }
      },
      series: [
        {
          name: '人数',
          type: 'pie',
          radius: ['45%', '60%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              color: '#f00'
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          },
          data: []
        }
      ]
    }
    // 体温情况饼图
    private temperaturePieChartVos:any = {
      title: {
        text: '',
        subtext: '数量(人)',
        top: '35%',
        left: '50%',
        textAlign: 'center',
        textStyle: {
          fontSize: '20'
        }
      },
      color: ['#FE5578', '#6C5CE7', '#1875F0', '#1CD1A1'],
      tooltip: {
        trigger: 'item',
        formatter(item:any) {
          let content = ''
          content = item.name + ':' + ' ' + item.value + '人'
          return content
        }
      },
      legend: {
        orient: 'vertical',
        left: 0,
        bottom: 0,
        formatter: (name:string) => {
          let content = ''
          this.temperaturePieChartVos.series[0].data.map((item:any) => {
            if (item.name === name) {
              content = item.name + ' ' + item.value + '人 ' + item.precent
            }
          })
          return content
        }
      },
      series: [
        {
          name: '人数',
          type: 'pie',
          radius: ['45%', '60%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              color: '#f00'
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          },
          data: []
        }
      ]
    }
    // 精神状况饼图
    private spiritPieChartVos:any = {
      title: {
        text: '',
        subtext: '数量(人)',
        top: '35%',
        left: '50%',
        textAlign: 'center',
        textStyle: {
          fontSize: '20'
        }
      },
      color: ['#FE5578', '#6C5CE7', '#1875F0', '#1CD1A1'],
      tooltip: {
        trigger: 'item',
        formatter(item:any) {
          let content = ''
          content = item.name + ':' + ' ' + item.value + '人'
          return content
        }
      },
      legend: {
        orient: 'vertical',
        left: 0,
        bottom: 0,
        formatter: (name:string) => {
          let content = ''
          this.spiritPieChartVos.series[0].data.map((item:any) => {
            if (item.name === name) {
              content = item.name + ' ' + item.value + '人 ' + item.precent
            }
          })
          return content
        }
      },
      series: [
        {
          name: '人数',
          type: 'pie',
          radius: ['45%', '60%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              color: '#f00'
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          },
          data: []
        }
      ]
    }
    // 口腔状况饼图
    private mouthPieChartVos:any = {
      title: {
        text: '',
        subtext: '数量(人)',
        top: '35%',
        left: '50%',
        textAlign: 'center',
        textStyle: {
          fontSize: '20'
        }
      },
      color: ['#FE5578', '#6C5CE7', '#1875F0', '#1CD1A1'],
      tooltip: {
        trigger: 'item',
        formatter(item:any) {
          let content = ''
          content = item.name + ':' + ' ' + item.value + '人'
          return content
        }
      },
      legend: {
        orient: 'vertical',
        left: 0,
        bottom: 0,
        formatter: (name:string) => {
          let content = ''
          this.mouthPieChartVos.series[0].data.map((item:any) => {
            if (item.name === name) {
              content = item.name + ' ' + item.value + '人 ' + item.precent
            }
          })
          return content
        }
      },
      series: [
        {
          name: '人数',
          type: 'pie',
          radius: ['45%', '60%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              color: '#f00'
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          },
          data: []
        }
      ]
    }
    // 皮肤状况饼图
    private skinPieChartVos:any = {
      title: {
        text: '',
        subtext: '数量(人)',
        top: '35%',
        left: '50%',
        textAlign: 'center',
        textStyle: {
          fontSize: '20'
        }
      },
      color: ['#FE5578', '#6C5CE7', '#1875F0', '#1CD1A1'],
      tooltip: {
        trigger: 'item',
        formatter(item:any) {
          let content = ''
          content = item.name + ':' + ' ' + item.value + '人'
          return content
        }
      },
      legend: {
        orient: 'vertical',
        left: 0,
        bottom: 0,
        formatter: (name:string) => {
          let content = ''
          this.skinPieChartVos.series[0].data.map((item:any) => {
            if (item.name === name) {
              content = item.name + ' ' + item.value + '人 ' + item.precent
            }
          })
          return content
        }
      },
      series: [
        {
          name: '人数',
          type: 'pie',
          radius: ['45%', '60%'],
          center: ['50%', '40%'],
          avoidLabelOverlap: false,
          label: {
            normal: {
              show: false,
              position: 'center',
              color: '#f00'
            }
          },
          labelLine: {
            normal: {
              show: true
            }
          },
          data: []
        }
      ]
    }
    // 应检查人数
    private originalCount:number = 0
    // 已检查人数
    private realityCount:number = 0
    // 异常人数
    private unusualCount:number = 0
    // 未检查人数
    private undoneCount:number = 0
    private detailInfoForm:any = {
      studentName: '',
      temperature: '',
      spirit: '',
      mouth: '',
      skin: '',
      other: '',
      checkType: 102
    }
    private classChecked:any = { campusId: '', classroomId: '' }
    /* 异常学生弹框 */
    private abnormityVisible:boolean = false
    /* 未检查学生弹框 */
    private uncheckVisible:boolean = false

    @Watch('staticTime', { immediate: true, deep: true })
    onChangeValue(newVal:string[], oldValue:string[]) {
      this.staticForm.fromTime = newVal.length ? newVal[0] : ''
      this.staticForm.toTime = newVal.length ? newVal[1] : ''
    }

    created() {
      this.getMorningCheckStatic()
      this.getMorningCheckPieStatic()
      this.getMorningCheckNumber()
    }
    /**
     * 查看异常学生
     */
    private previewAbnormity() {
      this.abnormityVisible = true
    }
    /**
     * 查看未检查学生
     */
    private previewUnchecked() {
      this.uncheckVisible = true
      this.$nextTick(() => {
        (this.$refs.uncheckTable as any).search()
      })
    }
    /**
     * 导出详细数据
     */
    private async exportRecord() {
      let promise = null
      const resp = await healthExport({
        ...this.detailInfoForm,
        time: this.recordForm.time
      })
      window.location = (resp as any).message
      return promise
    }

    /**
     * 详细数据查询
     */
    private search() {
      (this.$refs.table as any).search()
    }

    /**
     * 详细数据重置
     */
    private reset() {
      this.detailInfoForm.studentName = ''
      this.detailInfoForm.temperature = ''
      this.detailInfoForm.spirit = ''
      this.detailInfoForm.skin = ''
      this.detailInfoForm.mouth = ''
      this.detailInfoForm.other = ''
      this.$nextTick(() => {
        (this.$refs.table as any).search()
      })
    }
    /**
     * 晨检统计柱状图
     */
    private getMorningCheckStatic() {
      morningCheckStatic({
        ...this.staticForm,
        classroomId: this.classChecked.classroomId,
        campusId: this.classChecked.campusId
      }).then(res => {
        this.options.xAxis[0].data = res.data.days || []
        this.options.series[0].data = res.data.normalCounts || []
        this.options.series[1].data = res.data.unusualCounts || []
        this.options.series[2].data = res.data.undoneCounts || []
        ;(this.$refs.staticChart as any).setOption(this.options)
      }).catch(() => {})
    }

    /**
     * 晨检统计人数
     */
    private getMorningCheckNumber() {
      morningCheckNumber({
        ...this.recordForm,
        classroomId: this.classChecked.classroomId,
        campusId: this.classChecked.campusId
      }).then(res => {
        this.originalCount = res.data.originalCount || 0
        this.realityCount = res.data.realityCount || 0
        this.unusualCount = res.data.unusualCount || 0
        this.undoneCount = res.data.undoneCount || 0
      }).catch(() => {})
    }
    /**
     * 晨检统计饼状图
     */
    private getMorningCheckPieStatic() {
      morningCheckPieStatic({
        ...this.recordForm,
        classroomId: this.classChecked.classroomId,
        campusId: this.classChecked.campusId
      }).then(res => {
        // 检查情况饼图
        this.checkPieChartVos.title.text = res.data.originalCount || 0
        this.checkPieChartVos.series[0].data = res.data.checkPieChartVos || []
        ;(this.$refs.checkPieChartVos as any).setOption(this.checkPieChartVos)
        // 检查结果饼图
        this.resultPieChartVos.title.text = res.data.realityCount || 0
        this.resultPieChartVos.series[0].data = res.data.resultPieChartVos || []
        ;(this.$refs.resultPieChartVos as any).setOption(this.resultPieChartVos)
        // 体温情况饼图
        this.temperaturePieChartVos.title.text = res.data.realityCount || 0
        this.temperaturePieChartVos.series[0].data = res.data.temperaturePieChartVos || []
        ;(this.$refs.temperaturePieChartVos as any).setOption(this.temperaturePieChartVos)
        // 精神状况饼图
        this.spiritPieChartVos.title.text = res.data.realityCount || 0
        this.spiritPieChartVos.series[0].data = res.data.spiritPieChartVos || []
        ;(this.$refs.spiritPieChartVos as any).setOption(this.spiritPieChartVos)
        // 口腔状况饼图
        this.mouthPieChartVos.title.text = res.data.realityCount || 0
        this.mouthPieChartVos.series[0].data = res.data.mouthPieChartVos || []
        ;(this.$refs.mouthPieChartVos as any).setOption(this.mouthPieChartVos)
        // 皮肤状况饼图
        this.skinPieChartVos.title.text = res.data.realityCount || 0
        this.skinPieChartVos.series[0].data = res.data.skinPieChartVos || []
        ;(this.$refs.skinPieChartVos as any).setOption(this.skinPieChartVos)
      }).catch(() => {})
    }

    /**
     * 晨检记录时间筛选
     */
    private morningCheckDayChange() {
      this.getMorningCheckPieStatic()
      this.getMorningCheckNumber()
      this.search()
    }

    /**
     * 切换班级
     */
    private changeClass() {
      console.log('change class')
      this.recordForm.classroomId = this.classChecked.classroomId
      this.getMorningCheckStatic()
      this.getMorningCheckPieStatic()
      this.getMorningCheckNumber()
      this.reset()
    }
}
